import React from "react";
import FirstPlaceIcon from "../../../Images/Startup-Spotlight/firstPlace.png";
import SecondPlaceIcon from "../../../Images/Startup-Spotlight/secondPlace.png";
import ThirdPlaceIcon from "../../../Images/Startup-Spotlight/thirdPlace.png";
import TagIcon from "../../../Images/Startup-Spotlight/TagIcon.png";
import CommentsIcon from "../../../Images/Startup-Spotlight/CommentIcon.png";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";
import "./MonthlyProducts.scss";

const MonthlyProducts = ({
	loading,
	monthlyLabel,
	activeStageTab,
	stageProducts,
	handleUpvoteProduct,
	handleDownvoteProduct,
	handleProductClick,
}) => {
	// Ensure stageProducts is always an array
	const products = Array.isArray(stageProducts) ? stageProducts : [];
	
	// Render skeleton loaders when loading
	const renderSkeletonProducts = () => {
		return Array(3)
			.fill()
			.map((_, index) => (
				<div className="product-card skeleton-card" key={`skeleton-${index}`}>
					<div className="card-content">
						<div className="product-logo">
							<SkeletonLoader type="avatar" width="60px" height="60px" />
						</div>
						<div className="product-info">
							<div className="product-title">
								<SkeletonLoader type="title" width="70%" />
							</div>
							<SkeletonLoader type="text" count={1} />
							<div className="product-tags">
								<SkeletonLoader type="text" width="80%" height="24px" />
							</div>
						</div>
					</div>

					<div className="card-metrics">
						<SkeletonLoader type="circle" width="30px" height="30px" />
						<SkeletonLoader type="circle" width="30px" height="30px" />
						<SkeletonLoader type="circle" width="30px" height="30px" />
					</div>
				</div>
			));
	};

	return (
		<div className="monthly-products">
			<h2>
				Top 3 <span className="monthly-products-label">Products({activeStageTab})</span> from{" "}
				{monthlyLabel || ""}
			</h2>
			<div className="products-container">
				{loading ? (
					renderSkeletonProducts()
				) : products.length > 0 ? (
					products.slice(0, 3).map((product, index) => (
						<div
							key={product._id}
							className="monthly-product-card"
							onClick={() => handleProductClick(product._id)}
						>
							{index === 0 && (
								<div className="medal-badge">
									<img src={FirstPlaceIcon} alt="First Place" />
								</div>
							)}
							{index === 1 && (
								<div className="medal-badge">
									<img src={SecondPlaceIcon} alt="Second Place" />
								</div>
							)}
							{index === 2 && (
								<div className="medal-badge">
									<img src={ThirdPlaceIcon} alt="Third Place" />
								</div>
							)}

							<div className="card-content">
								<div className="product-logo">
									<img
										src={product.logo || "/placeholder.svg"}
										alt={product.title}
									/>
								</div>
								<div className="product-info">
									<h3>{product.title}</h3>
									<p className="tagline">
										{product.tagline && product.tagline.length > 80
											? `${product.tagline.substring(0, 80)}...`
											: product.tagline}
									</p>
									<div className="product-tags">
										{product.tags &&
											product.tags.slice(0, 3).map((tag, idx) => (
												<span key={idx} className="tag">
													{tag}
												</span>
											))}
										{product.industry && (
											<span className="tag industry">{product.industry}</span>
										)}
									</div>
								</div>
							</div>

							<div className="card-metrics">
								<div
									className="metric-button upvote"
									title="Upvote"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
									</svg>
									<span>{product.upvotes ? product.upvotes.length : 0}</span>
								</div>

								<div
									className="metric-button downvote"
									title="Downvote"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3"></path>
									</svg>
									<span>
										{product.downvotes ? product.downvotes.length : 0}
									</span>
								</div>

								<div
									className="metric-button comments"
									title="Comments"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
									</svg>
									<span>
										{product.comments
											? product.firstComment
												? product.comments.length + 1
												: product.comments.length
											: 0}
									</span>
								</div>
							</div>
						</div>
					))
				) : (
					<p className="no-products">
						No {activeStageTab} products found for this month
					</p>
				)}
			</div>
		</div>
	);
};

export default MonthlyProducts;
